// ** Icons Import
import { Home, Circle, ArrowLeft } from "react-feather";

export default [
  {
    id: "refunds",
    title: "Refunds",
    icon: <ArrowLeft size={20} />,
    badge: "light-warning",
    // badgeText: "2",
    navLink: "/refunds",
    // children: [
    //   {
    //     id: "gelenIadeler",
    //     title: "Gelen İadeler",
    //     icon: <Circle size={12} />,
    //     // navLink: '/dashboard/analytics'
    //   },
    //   {
    //     id: "bekleyenIadeler",
    //     title: "Bekleyen Iadeler",
    //     icon: <Circle size={12} />,
    //     // navLink: '/dashboard/ecommerce'
    //   },
    //   {
    //     id: "yapılanIadeler",
    //     title: "Yapılan Iadeler",
    //     icon: <Circle size={12} />,
    //     // navLink: '/dashboard/ecommerce'
    //   },
    // ],
  },
];
